import { Component, Input } from '@angular/core';
import { IIdentityViewModel, IRecordCard } from '../../driver-background-check.view-models';
import { formatAddress, formatDate, formatName, formatPhone } from '../../../helpers';

@Component({
  selector: 'app-bgc-section-identity',
  templateUrl: './bgc-section-identity.component.html',
  styleUrls: ['./bgc-section-identity.component.scss', '../../driver-background-check.component.scss']
})
export class BgcSectionIdentityComponent {
  @Input() identity: IIdentityViewModel;
  @Input() sharedSsnCards: IRecordCard[] = [];

  get sectionNote(): string {
    return `${this.identity.individualsSharingSsn.length} shared SSN individual(s) found`;
  }

  trackByCard(index: number, card: IRecordCard): string {
    return card.id;
  }

  public readonly formatName = formatName;
  public readonly formatDate = formatDate;
  public readonly formatAddress = formatAddress;
  public readonly formatPhone = formatPhone;
}



// WEBPACK FOOTER //
// ./src/app/utils/driver-background-check/components/bgc-section-identity/bgc-section-identity.component.ts